// extracted by mini-css-extract-plugin
export default {"preloader":"OnboardingModal_preloader__PbQ6n","headerBlock":"OnboardingModal_headerBlock__q5NV0","modal":"OnboardingModal_modal__XanfQ"};